import { combineReducers } from 'redux';
import list from './list';
import changePassword from './changePassword';

export default combineReducers({ list, changePassword });
